module.exports = __webpack_public_path__ + "img/4s.5a394694.png";